import { render, staticRenderFns } from "./cly-multi-select.vue?vue&type=template&id=0061f76e"
import script from "./cly-multi-select.vue?vue&type=script&lang=js"
export * from "./cly-multi-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports